"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotobookImage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _photobook_imageModule = _interopRequireDefault(require("@albelli/arc-3/lib/photobook_image.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const PhotobookImage = _ref => {
  let {
    height = 80,
    className,
    src,
    fallback,
    fallbackSrc,
    fallbackHeight,
    opened,
    ...props
  } = _ref;
  const [isFailed, setIsFailed] = (0, _react.useState)(false);
  const [dimensions, setDimensions] = (0, _react.useState)({
    width: 80,
    height: height
  });
  const imageRef = /*#__PURE__*/_react.default.createRef();
  const setSize = (0, _react.useCallback)(() => {
    setDimensions({
      width: imageRef.current.width,
      height: imageRef.current.height
    });
  }, [imageRef]);
  (0, _react.useEffect)(() => {
    if (imageRef.current && imageRef.current.complete && imageRef.current.height !== height) setSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height]);
  (0, _react.useEffect)(() => {
    //If the image has loaded but it is not a valid
    if (imageRef.current && imageRef.current.complete) setIsFailed(!imageRef.current.naturalHeight || !imageRef.current.naturalWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var marginTop = dimensions.width / 5;
  if (isFailed) {
    return fallback || /*#__PURE__*/_react.default.createElement("img", _extends({
      alt: "PhotobookCover",
      src: fallbackSrc,
      style: {
        height: "".concat(fallbackHeight || height, "px")
      },
      "data-cy": "arc3-photobook-image"
    }, props));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_photobook_imageModule.default["arc3-photobook-image"], {
      [_photobook_imageModule.default["--opened"]]: opened
    }),
    style: {
      minWidth: dimensions.width,
      height: height,
      marginTop: marginTop
    },
    "data-cy": "arc3-photobook-image"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _photobook_imageModule.default["arc3-photobook-image-pages"]
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_photobook_imageModule.default["arc3-photobook-image-spine"], className)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    alt: "PhotobookSpine"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_photobook_imageModule.default["arc3-photobook-image-front"], className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _photobook_imageModule.default["arc3-photobook-image-front-crease"]
  }), /*#__PURE__*/_react.default.createElement("img", _extends({
    ref: imageRef,
    alt: "PhotobookCover",
    onLoad: setSize,
    src: src
  }, props, {
    onError: () => setIsFailed(true)
  }))));
};
exports.PhotobookImage = PhotobookImage;
PhotobookImage.propTypes = {
  /** Optional custom CSS classes */
  className: _propTypes.PropTypes.string,
  /** Image Src */
  src: _propTypes.PropTypes.string,
  /** Set internal image photobook height - will be skewed and become larger */
  height: _propTypes.PropTypes.number,
  /** Make photobook image appear opened on first page instead of on cover */
  opened: _propTypes.PropTypes.bool,
  /** Fallback can be provided in its entirety, or provide a src and height */
  fallback: _propTypes.PropTypes.element,
  /** Fallback Image Src, uses a square image a sa fallback */
  fallbackSrc: _propTypes.PropTypes.string,
  /** Fallback Image height can vary from the skewed photobook image */
  fallbackHeight: _propTypes.PropTypes.number
};